import * as Sentry from "@sentry/nextjs";

// Sentry gets sad if we try to use one file for all 3 envs (server, client, and
// edge) even though they are all the same. So we just create one config here
// and symlink all 3 to here

// These are copy/pasted from easypost-web's sentry config
const IGNORE_ERRORS = [
  "The operation is insecure.",
  "Access is denied.",
  "Failed to construct 'Worker'",
  "Cancelling nav due to unsaved changes. Please ignore.",
  // BEGIN COMMUNITY SUGGESTED IGNORE ERRORS
  // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
];
const DENY_URLS = [
  // Wistia video player
  /(.*).wistia.com/i,
  "cdn.walkme.com",
  // BEGIN COMMUNITY SUGGESTED DENY URLS
  // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  /undefined is not an object \(evaluating 'a.+\)/g,
];

Sentry.init({
  dsn: "https://9d8d9f66f03ebcd58e4ee07b2d765812@o23421.ingest.sentry.io/4506678948593664",
  enabled:
    // https://kb.easypo.net/en/Easypost/Engineering/RuntimeEnvironmentVariable
    // only enable sentry when deployed to shared-dev or prod
    process.env.EP_SHORT_ENVIRONMENT === "prod" ||
    process.env.EP_SHORT_ENVIRONMENT === "dev",

  // don't do performance tracing. We can revisit if we determine we need it
  enableTracing: false,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  denyUrls: DENY_URLS,
  ignoreErrors: IGNORE_ERRORS,
});
